import React, { Component } from "react";
import {
  Wrapper,
  Card,
  CardBody,
  Row,
  Title,
  Copy
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

class InviteTeamMemberCard extends Component {
  constructor(props) {
    super(props);

    this.handleRecruitDriversPress = this.handleRecruitDriversPress.bind(this);
    this.handleInviteTeamPress = this.handleInviteTeamPress.bind(this);
  }

  handleRecruitDriversPress() {
    this.props.selectActiveTeamMember("collect_dealfinders");
    this.props.appRedirect({
      redirect: "collectDealFinders"
    });
  }

  handleInviteTeamPress() {
    this.props.setInviteType("team_member");
    this.props.selectActiveTeamMember("invite");
    this.props.appRedirect({
      redirect: "inviteTeamMember"
    });
  }

  render() {
    if (
      this.props.user.team_clearance_level > 1 ||
      this.props.user.team_owner == 1
    ) {
      return (
        <Card>
          <CardBody>
            <Title>Invite Team Members</Title>
            <Copy></Copy>
            <Row>
              <PillButton
                style={{ marginLeft: 0, marginBottom: 0 }}
                onPress={this.handleInviteTeamPress}
                primary={true}
              >
                Invite By Email
              </PillButton>
              <PillButton
                style={{ marginLeft: 0, marginBottom: 0 }}
                onPress={this.handleRecruitDriversPress}
                primary={false}
              >
                Recruit Drivers
              </PillButton>
            </Row>
          </CardBody>
        </Card>
      );
    }

    return <Wrapper />;
  }
}

export default InviteTeamMemberCard;
